export const benefits = [
    {
      icon: 'fa-lightbulb',
      title: 'Innovative Environment',
      description: 'Work with cutting-edge technologies and contribute to groundbreaking pharmaceutical solutions for women\'s health.'
    },
    {
      icon: 'fa-chart-line',
      title: 'Career Growth',
      description: 'We invest in our employees\' development with training programs, mentorship, and advancement opportunities.'
    },
    {
      icon: 'fa-balance-scale',
      title: 'Work-Life Balance',
      description: 'Flexible work arrangements and wellness programs to support your professional and personal life.'
    },
    {
      icon: 'fa-users',
      title: 'Collaborative Team',
      description: 'Join a diverse team of experts who value teamwork, knowledge sharing, and mutual respect.'
    },
    {
      icon: 'fa-heart',
      title: 'Meaningful Impact',
      description: 'Your work will directly contribute to improving women\'s health and quality of life globally.'
    },
    {
      icon: 'fa-award',
      title: 'Competitive Rewards',
      description: 'We offer attractive compensation, benefits, and recognition for your contributions.'
    }
  ];